/*NPS相关
i:get || post
h:requestGet ||requestPost
*/
import axios from "../axios";
export default {
  npsDetailsApi: (product_nps_id, id) => {
    //NPS问卷详情
    return axios.get(
      `products/nps/survey/detail?product_nps_id=${product_nps_id}&id=${id}`,
    );
  },
  npsSubmitApi: (data) => {
    //NPS问卷提交
    return axios.post("products/nps/survey/submit", data);
  },
};
